import { queryOptions } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import {
  StudentsActivityMetricFilter,
  StudentsActivityMetricsResponse,
} from "@/reports/types";

export const studentsActivityMetricsQueries = {
  all: () => [ApiCatalog.studentsActivityMetrics.key] as const,
  filter: (
    queryParams: StudentsActivityMetricFilter,
    enabled: boolean = true,
  ) =>
    queryOptions({
      queryKey: [...studentsActivityMetricsQueries.all(), { ...queryParams }],
      queryFn: () =>
        api().get<StudentsActivityMetricsResponse>(
          ApiCatalog.studentsActivityMetrics.endpoint,
          {
            queryParams,
          },
        ),
      enabled,
    }),
};
